import { startG3Telemetry } from "./g3-telemetry/index.js";

startG3Telemetry({
  ingestUrl: G3_INGEST_URL,
  reportToken: G3_REPORT_TOKEN,
  commit: G3_COMMIT_SHA,
  deployUrl: G3_DEPLOY_URL,
});

import "./style.css";

const list = document.getElementById("counters");
const total = document.getElementById("total");
const error = document.getElementById("error");
const form = document.getElementById("add");
const input = document.getElementById("name");

async function api(method, path, body) {
  const res = await fetch(`/api/counters${path}`, {
    method,
    headers: body ? { "content-type": "application/json" } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || `request failed (${res.status})`);
  return res.status === 204 ? null : res.json();
}

function button(key, label, text, onClick) {
  const b = document.createElement("button");
  b.type = "button";
  b.dataset.key = key;
  b.textContent = text;
  b.setAttribute("aria-label", label);
  b.addEventListener("click", onClick);
  return b;
}

function render(counters) {
  total.textContent = `Total: ${counters.reduce((sum, c) => sum + c.value, 0)}`;
  // Rows are rebuilt; put focus back on the button that had it.
  const focused = document.activeElement?.dataset?.key;
  list.replaceChildren(
    ...counters.map((c) => {
      const li = document.createElement("li");
      const name = document.createElement("span");
      name.className = "name";
      name.textContent = c.name;
      const value = document.createElement("output");
      value.textContent = c.value;
      li.append(
        name,
        button(`${c.id}-dec`, `Decrement ${c.name}`, "−", () => act("POST", `/${c.id}/decrement`)),
        value,
        button(`${c.id}-inc`, `Increment ${c.name}`, "+", () => act("POST", `/${c.id}/increment`)),
        button(`${c.id}-del`, `Delete ${c.name}`, "Delete", () => act("DELETE", `/${c.id}`)),
      );
      return li;
    }),
  );
  if (focused) [...list.querySelectorAll("button")].find((b) => b.dataset.key === focused)?.focus();
}

// Every change is followed by a fresh list, so the page shows what the server holds.
async function act(method, path, body) {
  try {
    await api(method, path, body);
    error.textContent = "";
  } catch (e) {
    error.textContent = e.message;
  }
  await refresh();
}

// Only the newest list request may render, so a late answer cannot show an older value.
let latest = 0;
async function refresh() {
  const mine = ++latest;
  try {
    const counters = await api("GET", "");
    if (mine === latest) render(counters);
  } catch (e) {
    error.textContent = e.message;
  }
}

form.addEventListener("submit", async (e) => {
  e.preventDefault();
  await act("POST", "", { name: input.value });
  if (!error.textContent) input.value = "";
});

document.getElementById("reset").addEventListener("click", () => act("POST", "/reset"));

refresh();
